export const fullTrim = (text: string) => {
  return text.replace(/^(<div>|\s|\n|<\/div>|<br>)*|(<div>|\s|\n|<\/div>|<br>)*$/gs, '')
}
